import { render } from "./CategoryPicker.vue?vue&type=template&id=ffd5d2b0"
import script from "./CategoryPicker.vue?vue&type=script&lang=js"
export * from "./CategoryPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__